/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const LOCATION_TYPE = 'Sub-Realm Type';
export const LOCATION_NAME = 'Sub-Realm Name';
export const DISPLAY_NAME = 'Display Name';
export const LOCATION_ADDRESS = 'Sub-Realm Address';
export const ADD = 'Add';
export const EDIT = 'Edit';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';
export const ADD_LOCATION = 'Add Sub-Realm';
export const EDIT_LOCATION = 'Edit Sub-Realm';
export const IDP_DISABLE_WARN_MSG = 'Disabling this option will block user sign-ins. Users created in Blue Yonder User store will no longer be able to log in to this realm. Click Cancel to keep the option enabled, or click {0} to confirm disabling it.';
export const DROPDOWN_MAX_HEIGHT = 350;

export const HELPER_MESSAGE = '* Required'
export const HELPER_ERROR_MESSAGE = 'Sub-Realm {0} is required';
export const LOCATION_NAME_VALIDATION_MESSAGE = 'Sub-Realm name should only contain alphabetic characters, digits, underscores and hyphens. Size should be between 5 and 20.';

export const LOCATION_CREATE_SUCCESS = 'Sub-Realm {0} has been created';
export const LOCATION_EDIT_SUCCESS = 'Sub-Realm {0} has been edited';
export const LOCATION_CREATE_ERROR = 'Error while creating Sub-Realm';
export const LOCATION_EDIT_ERROR = 'Error while editing Sub-Realm';
